const config = {
    apiUrl: "https://api.zhadorack.com"  // URL base de la API
  };
  
  export default config;
  